<template>
  <div class="teeth-select-popup">
    <div class="teeth-select-popup__switch">
      <p>Молочный прикус</p>
      <v-switch
        @click.stop
        v-model="isMilkBite"
        inset
        hide-details />
    </div>
    <div
      class="teeth-select-popup__teeth"
      v-if="isMilkBite">
      <tooth-up-5
        v-bind:number="55"
        v-bind:selected="selected[55]"
        v-on:toggle="onToggle" />
      <tooth-up-4
        v-bind:number="54"
        v-bind:selected="selected[54]"
        v-on:toggle="onToggle" />
      <tooth-up-3
        v-bind:number="53"
        v-bind:selected="selected[53]"
        v-on:toggle="onToggle" />
      <tooth-up-2
        v-bind:number="52"
        v-bind:selected="selected[52]"
        v-on:toggle="onToggle" />
      <tooth-up-1
        v-bind:number="51"
        v-bind:selected="selected[51]"
        v-on:toggle="onToggle" />
      <tooth-up-1
        v-bind:flip="true"
        v-bind:number="61"
        v-bind:selected="selected[61]"
        v-on:toggle="onToggle" />
      <tooth-up-2
        v-bind:flip="true"
        v-bind:number="62"
        v-bind:selected="selected[62]"
        v-on:toggle="onToggle" />
      <tooth-up-3
        v-bind:flip="true"
        v-bind:number="63"
        v-bind:selected="selected[63]"
        v-on:toggle="onToggle" />
      <tooth-up-4
        v-bind:flip="true"
        v-bind:number="64"
        v-bind:selected="selected[64]"
        v-on:toggle="onToggle" />
      <tooth-up-5
        v-bind:flip="true"
        v-bind:number="65"
        v-bind:selected="selected[65]"
        v-on:toggle="onToggle" />
    </div>
    <div
      class="teeth-select-popup__teeth"
      v-else>
      <tooth-up-8
        v-bind:number="18"
        v-bind:selected="selected[18]"
        v-on:toggle="onToggle" />
      <tooth-up-7
        v-bind:number="17"
        v-bind:selected="selected[17]"
        v-on:toggle="onToggle" />
      <tooth-up-6
        v-bind:number="16"
        v-bind:selected="selected[16]"
        v-on:toggle="onToggle" />
      <tooth-up-5
        v-bind:number="15"
        v-bind:selected="selected[15]"
        v-on:toggle="onToggle" />
      <tooth-up-4
        v-bind:number="14"
        v-bind:selected="selected[14]"
        v-on:toggle="onToggle" />
      <tooth-up-3
        v-bind:number="13"
        v-bind:selected="selected[13]"
        v-on:toggle="onToggle" />
      <tooth-up-2
        v-bind:number="12"
        v-bind:selected="selected[12]"
        v-on:toggle="onToggle" />
      <tooth-up-1
        v-bind:number="11"
        v-bind:selected="selected[11]"
        v-on:toggle="onToggle" />
      <tooth-up-1
        v-bind:flip="true"
        v-bind:number="21"
        v-bind:selected="selected[21]"
        v-on:toggle="onToggle" />
      <tooth-up-2
        v-bind:flip="true"
        v-bind:number="22"
        v-bind:selected="selected[22]"
        v-on:toggle="onToggle" />
      <tooth-up-3
        v-bind:flip="true"
        v-bind:number="23"
        v-bind:selected="selected[23]"
        v-on:toggle="onToggle" />
      <tooth-up-4
        v-bind:flip="true"
        v-bind:number="24"
        v-bind:selected="selected[24]"
        v-on:toggle="onToggle" />
      <tooth-up-5
        v-bind:flip="true"
        v-bind:number="25"
        v-bind:selected="selected[25]"
        v-on:toggle="onToggle" />
      <tooth-up-6
        v-bind:flip="true"
        v-bind:number="26"
        v-bind:selected="selected[26]"
        v-on:toggle="onToggle" />
      <tooth-up-7
        v-bind:flip="true"
        v-bind:number="27"
        v-bind:selected="selected[27]"
        v-on:toggle="onToggle" />
      <tooth-up-8
        v-bind:flip="true"
        v-bind:number="28"
        v-bind:selected="selected[28]"
        v-on:toggle="onToggle" />
    </div>
    <div
      v-if="isMilkBite"
      class="teeth-select-popup__teeth">
      <tooth-down-5
        v-bind:number="85"
        v-bind:selected="selected[85]"
        v-on:toggle="onToggle" />
      <tooth-down-4
        v-bind:number="84"
        v-bind:selected="selected[84]"
        v-on:toggle="onToggle" />
      <tooth-down-3
        v-bind:number="83"
        v-bind:selected="selected[83]"
        v-on:toggle="onToggle" />
      <tooth-down-2
        v-bind:number="82"
        v-bind:selected="selected[82]"
        v-on:toggle="onToggle" />
      <tooth-down-1
        v-bind:number="81"
        v-bind:selected="selected[81]"
        v-on:toggle="onToggle" />
      <tooth-down-1
        v-bind:flip="true"
        v-bind:number="71"
        v-bind:selected="selected[71]"
        v-on:toggle="onToggle" />
      <tooth-down-2
        v-bind:flip="true"
        v-bind:number="72"
        v-bind:selected="selected[72]"
        v-on:toggle="onToggle" />
      <tooth-down-3
        v-bind:flip="true"
        v-bind:number="73"
        v-bind:selected="selected[73]"
        v-on:toggle="onToggle" />
      <tooth-down-4
        v-bind:flip="true"
        v-bind:number="74"
        v-bind:selected="selected[74]"
        v-on:toggle="onToggle" />
      <tooth-down-5
        v-bind:flip="true"
        v-bind:number="75"
        v-bind:selected="selected[75]"
        v-on:toggle="onToggle" />
    </div>
    <div
      v-else
      class="teeth-select-popup__teeth">
      <tooth-down-8
        v-bind:number="48"
        v-bind:selected="selected[48]"
        v-on:toggle="onToggle" />
      <tooth-down-7
        v-bind:number="47"
        v-bind:selected="selected[47]"
        v-on:toggle="onToggle" />
      <tooth-down-6
        v-bind:number="46"
        v-bind:selected="selected[46]"
        v-on:toggle="onToggle" />
      <tooth-down-5
        v-bind:number="45"
        v-bind:selected="selected[45]"
        v-on:toggle="onToggle" />
      <tooth-down-4
        v-bind:number="44"
        v-bind:selected="selected[44]"
        v-on:toggle="onToggle" />
      <tooth-down-3
        v-bind:number="43"
        v-bind:selected="selected[43]"
        v-on:toggle="onToggle" />
      <tooth-down-2
        v-bind:number="42"
        v-bind:selected="selected[42]"
        v-on:toggle="onToggle" />
      <tooth-down-1
        v-bind:number="41"
        v-bind:selected="selected[41]"
        v-on:toggle="onToggle" />
      <tooth-down-1
        v-bind:flip="true"
        v-bind:number="31"
        v-bind:selected="selected[31]"
        v-on:toggle="onToggle" />
      <tooth-down-2
        v-bind:flip="true"
        v-bind:number="32"
        v-bind:selected="selected[32]"
        v-on:toggle="onToggle" />
      <tooth-down-3
        v-bind:flip="true"
        v-bind:number="33"
        v-bind:selected="selected[33]"
        v-on:toggle="onToggle" />
      <tooth-down-4
        v-bind:flip="true"
        v-bind:number="34"
        v-bind:selected="selected[34]"
        v-on:toggle="onToggle" />
      <tooth-down-5
        v-bind:flip="true"
        v-bind:number="35"
        v-bind:selected="selected[35]"
        v-on:toggle="onToggle" />
      <tooth-down-6
        v-bind:flip="true"
        v-bind:number="36"
        v-bind:selected="selected[36]"
        v-on:toggle="onToggle" />
      <tooth-down-7
        v-bind:flip="true"
        v-bind:number="37"
        v-bind:selected="selected[37]"
        v-on:toggle="onToggle" />
      <tooth-down-8
        v-bind:flip="true"
        v-bind:number="38"
        v-bind:selected="selected[38]"
        v-on:toggle="onToggle" />
    </div>
    <div class="teeth-select-popup__filters">
      <button
        class="teeth-select-popup__filters__item"
        type="button"
        v-bind:disabled="onlyView"
        v-on:click="selectAll">Все зубы</button>
      <button
        class="teeth-select-popup__filters__item"
        type="button"
        v-bind:disabled="onlyView"
        v-on:click="selectUp">В/Ч</button>
      <button
        class="teeth-select-popup__filters__item"
        type="button"
        v-bind:disabled="onlyView"
        v-on:click="selectDown">Н/Ч</button>
      <button
        class="teeth-select-popup__filters__item"
        type="button"
        v-bind:disabled="onlyView"
        v-on:click="clearAll">Сбросить</button>
    </div>
    <template v-if="onlyView">
      <input-checkbox
        v-bind:disabled="onlyView"
        v-bind:value="isOralCavitySelected"
        title="Полость рта" />
      <button
        class="teeth-select-popup__buttons__button-cancel only-view"
        type="submit"
        v-on:click="onCancel">
        Закрыть</button>
    </template>
    <div v-else class="teeth-select-popup__buttons">
      <input-checkbox
        v-bind:value="isOralCavitySelected"
        v-on:input="onToggleOralCavity"
        title="Полость рта" />
      <slot name="actions">
        <button
          class="teeth-select-popup__buttons__button-cancel"
          type="submit"
          v-on:click="onCancel">Отмена</button>
        <button
          class="teeth-select-popup__buttons__button-submit"
          type="button"
          v-on:click="onSubmit">Ок</button>
      </slot>
    </div>
  </div>
</template>

<script>
import { builtInPopoverMixin } from '@/mixins/builtInPopoverMixin';
import ToothDown1 from './popupTeeth/ToothDown1.vue';
import ToothDown2 from './popupTeeth/ToothDown2.vue';
import ToothDown3 from './popupTeeth/ToothDown3.vue';
import ToothDown4 from './popupTeeth/ToothDown4.vue';
import ToothDown5 from './popupTeeth/ToothDown5.vue';
import ToothDown6 from './popupTeeth/ToothDown6.vue';
import ToothDown7 from './popupTeeth/ToothDown7.vue';
import ToothDown8 from './popupTeeth/ToothDown8.vue';
import ToothUp1 from './popupTeeth/ToothUp1.vue';
import ToothUp2 from './popupTeeth/ToothUp2.vue';
import ToothUp3 from './popupTeeth/ToothUp3.vue';
import ToothUp4 from './popupTeeth/ToothUp4.vue';
import ToothUp5 from './popupTeeth/ToothUp5.vue';
import ToothUp6 from './popupTeeth/ToothUp6.vue';
import ToothUp7 from './popupTeeth/ToothUp7.vue';
import ToothUp8 from './popupTeeth/ToothUp8.vue';
import InputCheckbox from './InputCheckbox.vue';
/**
 * @description Номера зубов верхней челюсти.
 * @type {number[]}
 */
const teethNumbersUp = [
  11, 12, 13, 14, 15, 16, 17, 18,
  21, 22, 23, 24, 25, 26, 27, 28,
];

/**
 * @description Номера зубов нижней челюсти.
 * @type {number[]}
 */
const teethNumbersDown = [
  31, 32, 33, 34, 35, 36, 37, 38,
  41, 42, 43, 44, 45, 46, 47, 48,
];

/**
 * @description Номера молочных зубов нижней челюсти.
 * @type {number[]}
 */
const teethMilkNumbersUp = [
  51, 52, 53, 54, 55,
  61, 62, 63, 64, 65,
];

/**
 * @description Номера молочных зубов верхней челюсти.
 * @type {number[]}
 */
const teethMilkNumbersDown = [
  71, 72, 73, 74, 75,
  81, 82, 83, 84, 85,
];

/**
 * @description Полость рта.
 * @type {string}
 */
const ORAL_CAVITY = 'oral-cavity';

/**
 * @description Полость рта молочного прикуса.
 * @type {string}
 */
const ORAL_CAVITY_MILK = 'oral-cavity-milk';

/**
 * @description Части.
 * @type {Object.<string,{title:string,value:string}>}
 */
const PARTS = {
  [ORAL_CAVITY]: { title: 'полость рта', value: ORAL_CAVITY },
  [ORAL_CAVITY_MILK]: { title: 'полость рта (молочный прикус)', value: ORAL_CAVITY_MILK },
};

export default {
  components: {
    ToothDown1,
    ToothDown2,
    ToothDown3,
    ToothDown4,
    ToothDown5,
    ToothDown6,
    ToothDown7,
    ToothDown8,
    ToothUp1,
    ToothUp2,
    ToothUp3,
    ToothUp4,
    ToothUp5,
    ToothUp6,
    ToothUp7,
    ToothUp8,
    InputCheckbox,
  },
  computed: {
    isOralCavitySelected() {
      return this.isMilkBite
        ? this.dentalParts.includes(ORAL_CAVITY_MILK)
        : this.dentalParts.includes(ORAL_CAVITY);
    },
  },
  data() {
    return {
      /**
       * @description Стоматологические части.
       * @type {string[]}
       */
      dentalParts: this.initialDentalParts.map(({ value }) => value),
      /**
       * @description Молочный прикус.
       * @type {boolean}
       */
      isMilkBite: this.isMilkBiteDefault,
      /**
       * @description Выбранные зубы.
       * @type {boolean[]}
       */
      selected: [],
      /**
       * @description Выбрана группа зубов.
       */
      selectedGroup: false,
    };
  },
  methods: {
    dispatchSelected() {
      const teeth = [];
      this.selected.forEach((value, index) => {
        if (value === true) {
          teeth.push(index);
        }
      });
      const dentalParts = this.dentalParts.map((value) => PARTS[value]);
      this.$emit('selected', teeth, dentalParts, this.selectedGroup);
    },
    /**
     * @description Сбросить выбранные зубы.
     * @returns {void}
     */
    clearAll() {
      const teeth = this.isMilkBite
        ? [...teethMilkNumbersUp, ...teethMilkNumbersDown]
        : [...teethNumbersUp, ...teethNumbersDown];
      teeth.forEach((number) => {
        this.$set(this.selected, number, false);
      });
      this.selectedGroup = false;
      this.dispatchSelected();
    },
    /**
     * @description Выбрать все зубы.
     * @returns {void}
     */
    selectAll() {
      const teeth = this.isMilkBite
        ? [...teethMilkNumbersUp, ...teethMilkNumbersDown]
        : [...teethNumbersUp, ...teethNumbersDown];
      this.selectedGroup = true;
      this.setTeeth(teeth);
    },
    /**
     * @description Выбрать зубы верхней челюсти.
     * @returns {void}
     */
    selectUp() {
      const teeth = this.isMilkBite ? teethMilkNumbersUp : teethNumbersUp;
      this.selectedGroup = true;
      this.setTeeth(teeth);
    },
    /**
     * @description Выбрать зубы нижней челюсти.
     * @returns {void}
     */
    selectDown() {
      const teeth = this.isMilkBite ? teethMilkNumbersDown : teethNumbersDown;
      this.selectedGroup = true;
      this.setTeeth(teeth);
    },
    /**
     * @description Обработать переключение полости рта.
     * @returns {void}
     */
    onToggleOralCavity(isSelected) {
      const value = this.isMilkBite ? ORAL_CAVITY_MILK : ORAL_CAVITY;
      const isContains = this.dentalParts.includes(value);
      if (!isSelected && isContains) {
        const index = this.dentalParts.indexOf(value);
        if (index > -1) {
          this.$delete(this.dentalParts, index);
        }
      } else if (isSelected && !isContains) {
        this.dentalParts.push(value);
      }
      this.dispatchSelected();
    },
    /**
     * @description Обработать переключение.
     * @param {number} tooth Номер зуба.
     * @returns {void}
     */
    onToggle(tooth) {
      if (this.onlyView) { return; }
      const value = this.selected[tooth] || false;
      if (value === false) {
        const teeth = this.isMilkBite
          ? [...teethNumbersUp, ...teethNumbersDown]
          : [...teethMilkNumbersUp, ...teethMilkNumbersDown];
        teeth.forEach((number) => {
          this.$set(this.selected, number, false);
        });
      }
      this.selectedGroup = false;
      this.$set(this.selected, tooth, !value);
      this.dispatchSelected();
    },
    /**
     * @description Обработать подтверждение.
     * @returns {void}
     */
    onSubmit() {
      const selected = [];
      this.selected.forEach((value, index) => {
        if (value === true) {
          selected.push(index);
        }
      });
      const parts = this.dentalParts.map((value) => PARTS[value]);
      this.$emit('submit', selected, parts, this.selectedGroup);
      this.closePopover();
    },
    /**
     * @description Обработать отмену.
     * @returns {void}
     */
    onCancel() {
      this.selected = [];
      this.initialSelected.forEach((number) => {
        this.$set(this.selected, number, true);
      });
      this.closePopover();
    },
    /**
     * @description Установить зубы.
     * @param {number[]} teeth Зубы.
     * @returns {void}
     */
    setTeeth(teeth) {
      this.selected = [];
      teeth.forEach((number) => {
        this.$set(this.selected, number, true);
      });
      this.dispatchSelected();
    },
  },
  watch: {
    initialSelected: {
      handler(value) {
        this.selected = [];
        value.forEach((number) => {
          this.$set(this.selected, number, true);
        });
      },
      immediate: true,
    },
  },
  props: {
    /**
     * @description Только для просмотра.
     * @type {boolean}
     */
    onlyView: { default: () => false, type: Boolean },
    /**
     * @descriptionДобавочные Добавочные части.
     * @type {any[]}
     */
    initialDentalParts: { default: () => [], type: Array },
    /**
     * @description Номера выбранных зубов.
     * @type {number[]}
     */
    initialSelected: { type: Array, default: () => [] },
    /**
     * @description Базовое состояние прикуса
     * @type {boolean}
     */
    isMilkBiteDefault: { type: Boolean, default: () => false },
  },
  mixins: [builtInPopoverMixin],
};
</script>

<style lang="scss">
@use "@/scss/buttons";
.menuable__content__active {
  min-width: fit-content !important;
  @media screen and (max-width: 480px) {
    min-width: inherit !important;
  }
}
.teeth-select-popup {
  display: flex;
  flex-direction: column;
  padding: 26px 30px;
  gap: 30px;
  width: 100%;
  overflow: auto;
  &__buttons {
    justify-content: flex-end;
    display: grid;
    grid-template-columns: 1fr 99px 123px;
    column-gap: 6px;
    &__button {
      &-cancel {
        @include buttons.btn-transparent(100%, 37px, 14px);
        &.only-view {
          align-self: flex-end;
          max-width: 123px;
        }
      }
      &-submit {
        @include buttons.btn-blue(100%, 37px, 14px);
      }
    }
  }
  &__filters {
    display: flex;
    flex-direction: row;
    gap: 18px;
    &__item {
      border-bottom: 1px dashed transparent;
      color: var(--action-color);
      cursor: pointer;
      font-size: 16px;
      font-weight: 400;
      line-height: 19px;
      &:hover {
        border-bottom: 1px dashed #0076c4;
        color: #0076c4;
        transition: color var(--animate-duration) ease 0s;
      }
    }
  }
  &__switch {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 20px;
    p {
      margin: 0;
      font-weight: 400;
      font-size: 16px;
      line-height: 17px;
      color: var(--reading-color);
    }
    .v-input--selection-controls__input:hover
      .v-input--selection-controls__ripple:before {
      content: none;
    }
    .v-input--switch .v-input--switch__track {
      background: #eaeff3 !important;
      border: 1px solid #c2cfe0;
      border-radius: 15px;
    }
    .v-input--switch .v-input--switch__thumb {
      color: #90a0b7;
    }
    .v-input--selection-controls {
      margin: 0 !important;
      padding: 5px !important;
    }
  }
  &__teeth {
    display: flex;
    flex-direction: row;
    gap: 12px;
  }
}
.tooth-popup {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  &.flip {
    .tooth-popup {
      &__parts {
        transform: scaleX(-1);
      }
    }
  }
  &__number {
    color: black;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    transition: color var(--animate-duration) ease 0s;
  }
  &.selected {
    .tooth-popup {
      &__number {
        color: var(--action-color);
      }
      &__parts > path {
        fill: #f8e223;
        stroke: #b08400;
      }
    }
  }
  &__parts > path {
    transition: all var(--animate-duration) ease 0s;
    fill: white;
    stroke: #778f9f;
  }
  &:hover {
    .tooth-popup {
      &__number {
        color: var(--action-color);
      }
      &__parts > path {
        stroke: var(--action-color);
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .teeth-select-popup__buttons {
    grid-template-columns: 1fr;
    grid-gap: 10px;
  }
}
@media screen and (max-width: 480px) {
  .teeth-select-popup {
    padding: 15px 10px;
  }
}
</style>
